// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';

// function ProtectedRoute({ children }) {
//   const { isAuthenticated } = useAuth();

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// }

// export default ProtectedRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { canPerform } from '../../utils/permissions';

function ProtectedRoute({ children, feature, action = 'view' }) {
  const { isAuthenticated, user } = useAuth();

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ⭐ CHECK FEATURE PERMISSIONS IF SPECIFIED
  if (feature && !canPerform(feature, action)) {
    console.warn(`🚫 Access denied: User ${user?.username} cannot ${action} ${feature}`);
    
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f5f5f5',
        padding: '20px'
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          textAlign: 'center',
          maxWidth: '500px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>🚫</div>
          <h2 style={{ margin: '0 0 10px 0', color: '#333' }}>Access Denied</h2>
          <p style={{ color: '#666', margin: '10px 0 20px 0' }}>
            You don't have permission to access this resource.
          </p>
          <p style={{ fontSize: '14px', color: '#999', marginBottom: '20px' }}>
            Required permission: <strong>{action}</strong> on <strong>{feature}</strong>
          </p>
          <button 
            onClick={() => window.history.back()}
            style={{
              padding: '10px 20px',
              background: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
